/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_appsync_graphqlEndpoint": "https://aftw4njij5ea5lcjojsct4eb5u.appsync-api.us-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-rzkjicxnozexxjxb2x2mfolt3u",
    "aws_cognito_identity_pool_id": "us-west-2:51413df9-5df4-42d4-82d3-b32499ea2a84",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_zY5w4QOW4",
    "aws_user_pools_web_client_id": "csk4346rmvrdrmv2pfdamcrh0",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "pathway-content-media112617-production",
    "aws_user_files_s3_bucket_region": "us-west-2"
};


export default awsmobile;
